import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar'
import PageTitle from '../../components/pagetitle/PageTitle'
import ScrollTextAnimation from '../../components/ScrollTextAnimation/ScrollTextAnimation';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo-5.png'
import Contactpage from '../../components/Contactpage/Contactpage'

const ContactPage = () => {
    return (
        <Fragment>

            <Navbar
                hclass={'wpo-site-header wpo-header-style'}
                page={'contact'}
                Logo={Logo}
                col1={'col-lg-3 col-md-3 col-3 d-lg-none dl-block'}
                col2={'col-lg-5 col-md-6 col-6'}
                col3={'col-lg-5 col-md-1 col-1'}
                col4={'col-lg-2 col-md-2 col-2'}
            />

            {/* ✅ Wrapper: mobile spacing + no horizontal scroll */}
            <div
                style={{
                    paddingTop: "clamp(60px, 10vw, 100px)",
                    overflowX: "hidden",
                }}
            >
                <div>
                    <PageTitle pageTitle={''} pagesub={'Contact Us'} />
                </div>

                <ScrollTextAnimation />

                <Contactpage />

                <section className="wpo-contact-map-section">
                    <h2 className="hidden">Contact map</h2>

                    <div className="wpo-contact-map">
                        <iframe
                            title="Quality Homes And Builders Location"
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3768.661216160571!2d144.7467204!3d-37.8734797!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad68853f7fbb96d%3A0x8347c91592b93600!2s40b%20Wallace%20Ave%2C%20Point%20Cook%20VIC%203030%2C%20Australia!5e1!3m2!1sen!2sin!4v1768808490236!5m2!1sen!2sin"
                            width="100%"
                            height="450"
                            style={{ border: 0 }}
                            allowFullScreen
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                        ></iframe>
                    </div>
                </section>
            </div>

            <Footer />
            <Scrollbar />

        </Fragment>
    )
};

export default ContactPage;
